/**
 * Entry point for Photo Log tool.
 */

import { mountVueComponent } from '@client/core/bootstrap/mount-vue-component';
// eslint-disable-next-line no-restricted-imports
import PhotoLog from '@legacy/components/PhotoLog/PhotoLog.vue';

mountVueComponent(PhotoLog, {
  name: 'PhotoLogApp',
  mount: '#photo-log-app',
});
